import React, { useState, useEffect } from "react";
import "./CookieBanner.css";

type CookieBannerProps = {
  storageKey?: string;
  policyUrl?: string;
};

const CookieBanner: React.FC<CookieBannerProps> = ({
  storageKey = "cookieConsent",
  policyUrl = "/privacy-policy",
}) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(storageKey)) {
      setVisible(true);
    }
  }, [storageKey]);

  const accept = () => {
    localStorage.setItem(storageKey, "accepted");
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem(storageKey, "declined");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner-overlay">
      <div className="cookie-banner-box">
        <p className="cookie-banner-text">
          We use cookies to improve your experience. By clicking “Accept,” you
          agree to our use of cookies.&nbsp;
          <a href={policyUrl} target="_blank" rel="noopener noreferrer">
            Learn more
          </a>
        </p>
        <div className="cookie-banner-buttons">
          <button className="cookie-banner-button" onClick={decline}>
            Decline
          </button>
          <button className="cookie-banner-button primary" onClick={accept}>
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
